import { render, staticRenderFns } from "./OrderReturnPayment.vue?vue&type=template&id=25663ec2"
import script from "./OrderReturnPayment.vue?vue&type=script&lang=js"
export * from "./OrderReturnPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports